import { useEffect, useState } from "react";
import { io } from "socket.io-client";

let socket = null;
let refCount = 0;
let status = {
  connected: false,
  connecting: false,
  error: null,
  lastEvent: null,
  lastPing: null,
  latency: null,
};
const subscribers = new Set();

function notify(partial) {
  status = { ...status, ...partial };
  for (const cb of subscribers) cb(status);
}

function attachSocketEvents(instance) {
  if (!instance) return;
  instance.on("connect", () => {
    notify({ connected: true, connecting: false, error: null, lastEvent: "connect" });
  });
  instance.on("disconnect", (reason) => {
    notify({ connected: false, connecting: false, lastEvent: `disconnect:${reason}` });
  });
  instance.on("reconnect_attempt", () => {
    notify({ connecting: true, lastEvent: "reconnect_attempt" });
  });
  instance.on("reconnect", () => {
    notify({ connected: true, connecting: false, lastEvent: "reconnect" });
  });
  instance.on("connect_error", (err) => {
    notify({ error: err?.message || "connection error", lastEvent: "connect_error" });
  });
}
const data = process.env.REACT_APP_BACKEND_URL|| "192.168.1.8:5000";

// export function connectSocket(options = {}) {
//   if (!socket) {
//     notify({ connecting: true });

//     const backendUrl = process.env.REACT_APP_BACKEND_URL;
//     const wsProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
//     const SERVER_URL = `${wsProtocol}${backendUrl.replace(/^https?:/, "")}`;
    // const SERVER_URL = `ws://${process.env.REACT_APP_BACKEND_URL} `; // default bakend/
// const data="|| ${process.env.REACT_APP_BACKEND_URL}" 
export function connectSocket(options = {}) {
  if (!socket) {
    notify({ connecting: true });
    //  const SERVER_URL = `ws://192.168.1.8:8080`; // default bakend
     const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const wsProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    const SERVER_URL = `${wsProtocol}${backendUrl.replace(/^https?:/, "")}`;
    socket = io(SERVER_URL, {
      transports: ["websocket"],
    });
    console.log("socketssss", SERVER_URL,"Backend URL",backendUrl);
    attachSocketEvents(socket);
  }

  refCount += 1;
  return socket;
}

// export function connectSocket(options) {
//   if (!socket) {
//     notify({ connecting: true });
//     socket = io(undefined, { transports: ["websocket"], ...options });
//     attachSocketEvents(socket);
//   }
//   refCount += 1;
//   return socket;
// }

export function releaseSocket() {
  refCount = Math.max(0, refCount - 1);
  if (refCount === 0 && socket) {
    socket.disconnect();
    socket = null;
    notify({ connected: false, connecting: false, lastEvent: "disconnected_by_client" });
  }
}

export function getSocket() {
  return socket;
}

export function pingSocket(timeout = 4000) {
  return new Promise((resolve, reject) => {
    const created = !socket;
    const instance = socket || connectSocket();
    const start = Date.now();
    let settled = false;
    const timer = setTimeout(() => {
      if (!settled) {
        settled = true;
        notify({ latency: null, lastPing: Date.now(), error: "ping timeout" });
        if (created) releaseSocket();
        reject(new Error("ping timeout"));
      }
    }, timeout);
    instance.emit("health:ping", { ts: start }, (ack) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      const latency = Date.now() - start;
      notify({ latency, lastPing: Date.now(), error: null, lastEvent: "pong" });
      if (created) releaseSocket();
      resolve({ latency, ack });
    });
  });
}

export function useSocketStatus() {
  const [current, setCurrent] = useState(status);
  useEffect(() => {
    const handler = (next) => setCurrent(next);
    subscribers.add(handler);
    handler(status);
    return () => {
      subscribers.delete(handler);
    };
  }, []);
  return current;
}
